module.exports = __webpack_public_path__ + "img/shot_bigtx4.0366c32b.png";